import React from "react";
import PageError from "./error";
import ieSvg from "../../components/icons/ieSvg";
import FormRegister from "./form";
import {getInfoAction} from "../../store/actions/getInfoAction";
import {connect} from "react-redux";
import * as consts from "../../store/constants/userInfo";
import PageLoading from "../server/preload";

class PageRegister extends React.Component {
  componentDidMount() {
    document.title = "Стать самозанятым | FBalance";
    ieSvg();
    this.props.fetchData(process.env.REACT_APP_GATE + "client/registration/" + this.props.regType, this, consts.CLIENT_REGISTRATION);
  }


  render() {
    if (this.props.data.items) {
      switch (this.props.data.items.result.status) {
        case "ERROR":
          return <PageError
            infoTitle='Что-то пошло не так'
            infoMessage={this.props.data.items.result.errorMessage}
            infoLink={process.env.REACT_APP_ELF_URL}
            infoButton="Вернуться в интернет-банк"
          />;
        case "TIMEOUT":
          return <PageError
            infoTitle='Что-то пошло не так'
            infoMessage='Сервис временно недоступен, повторите операцию позже.'
            infoLink={process.env.REACT_APP_ELF_URL}
            infoButton="Вернуться в интернет-банк"
          />;
        default:
          return <FormRegister registerData={this.props.data.items.data} />
      }
    }
    else {
      return <PageLoading />;
    }
  }
}

const mapStateToProps = state => ({data: state.clientRegistration})

const mapDispatchToProps = dispatch => {
  return {fetchData: (url, parent, types) => dispatch(getInfoAction(url, parent, types))}
}

export default connect(mapStateToProps, mapDispatchToProps)(PageRegister);
